import { Box, SectionContent, SectionTitle, Typo, xlBumps } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { getCoverLevelOption, Quote } from '../../../domain'
import {
  TKey,
  tProduct,
  useWriskTranslation,
} from '../../../infrastructure/internationalisation'
import { ExcessExpandable } from '../excess'
import { ExclusionsExpandable } from './ExclusionsExpandable'
import { IncludedCoversExpandable } from './IncludedCoversExpandable'
import { OptionalCoversExpandable } from './OptionalCoversExpandable'

const tKey = TKey('components.your-cover')

export interface YourCoverSectionProps {
  quote: Quote
}

export const YourCoverSection: FunctionComponent<YourCoverSectionProps> = ({ quote }) => {
  const { t } = useWriskTranslation()

  const coverLevel = getCoverLevelOption(quote)?.coverLevel

  return (
    <Box width={1} mb={xlBumps}>
      <SectionTitle>{t(tKey('header'))}</SectionTitle>
      <SectionContent>
        <Box width={1} p={2} variant='raised'>
          <IncludedCoversExpandable
            reversed
            quote={quote}
            header={
              <Typo fontWeight='bold' typoSize='md'>
                {t(tProduct('cover-levels', coverLevel, 'label'))}
              </Typo>
            }
          />
          <ExcessExpandable
            reversed
            quote={quote}
            header={
              <Typo fontWeight='bold' typoSize='md'>
                {t(tKey('headings.excesses'))}
              </Typo>
            }
          />
          <OptionalCoversExpandable
            reversed
            quote={quote}
            showPremiums={true}
            header={
              <Typo fontWeight='bold' typoSize='md'>
                {t(tKey('headings.optional-covers'))}
              </Typo>
            }
          />
          <ExclusionsExpandable
            reversed
            header={
              <Typo fontWeight='bold' typoSize='md'>
                {t(tKey('headings.exclusions'))}
              </Typo>
            }
          />
        </Box>
      </SectionContent>
    </Box>
  )
}
